import { apiRequest } from "@common/api";

// A player's own profile in play-api: what they chose to show. Everyone's
// comes back in the dashboard feed.

export interface Profile {
  /** The game whose cover is their picture, by play key. */
  picture: string | null;
}

export async function myProfile(): Promise<Profile> {
  return (await apiRequest("/profile")).json();
}

export async function saveMyProfile(profile: Profile): Promise<Profile> {
  return (
    await apiRequest("/profile", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(profile),
    })
  ).json();
}
